import { generateRootObjectSchema, generateStringSchema, generateDateTimeSchema } from "components/cards/common/schema";
import { BaseParticleSpec, GetParticlePropsType, GetParticleSchemaType, generateParticleContainerSchema } from "components/cards/particles/BaseParticleSpec";
import { ImageParticleSpec } from "../../Core/Image/spec";
import { TextParticleSpec } from "../../Core/Text/spec";
import { ButtonParticleSpec } from "../../Core/Button/spec";

export const FavoriteParticleSpec = new BaseParticleSpec("Favorite Particle", generateRootObjectSchema({
  container: generateParticleContainerSchema({
    defaultValues: { fillHeight: false, fillWidth: false, centerContentHorizontally: false, padding: '0px 0px 0px 0.6rem' }
  }),
  itemKey: generateStringSchema("Item Key", "Identifier for the item being favorited."),
  mediaType: generateStringSchema("Media Type", "Type of media of the being favorited."),
  thumbnail: generateStringSchema("Thumbnail", "The image thumbnail for the background of the card."),
  titleText: generateStringSchema("Title Text", "The text for the title"),
  publishDateTime: generateDateTimeSchema("Publish Date Time", "Enter Publish Date and Time"),
  resolvedLink: generateStringSchema("Favorite Link", "The link for the favorited item"),
  addFavorite: ButtonParticleSpec.generateSchema("Add Favorite", "CTA for adding an item to Favorites", {
    defaultValues: {
      image: {
        icon: 'yc_icon_add_circle',
        iconColor: 'var(--theme-primary-highlight-color)',
        container: { width: '2rem', height: '2rem' }
      },
      text: {
        text: 'Add to playlist',
        transform: 'uppercase',
        color: 'var(--theme-primary-highlight-color)'
      },
      gap: '0.25rem'
    }
  }),
  favoriteAdded: ButtonParticleSpec.generateSchema("Remove Favorite", "CTA for removing an item from Favorites", {
    defaultValues: {
      image: {
        icon: 'yc_icon_check_fill',
        iconColor: 'var(--theme-primary-highlight-color)',
        container: { width: '2rem', height: '2rem' }
      },
      text: {
        text: 'Added to playlist',
        transform: 'uppercase',
        color: 'var(--theme-primary-highlight-color)'
      },
      gap: '0.25rem'
    }
  }),
  removeFavorite: ButtonParticleSpec.generateSchema("Remove Favorite", "CTA for removing an item from Favorites", {
    defaultValues: {
      container: { padding: '0px 0px 0.5rem 0.5rem' },
      text: {
        text: 'Undo',
        color: '#585858'
      }
    }
  }),
  favoritesLink: ButtonParticleSpec.generateSchema("Favorites List", "Link to user's Favorites page", {
    defaultValues: {
      container: { padding: '0px 0px 0.5rem 0.8rem' },
      text: {
        text: 'View playlist',
        color: 'var(--theme-primary-accent-color)'
      }
    }
  }),
  addedToastIcon: ImageParticleSpec.generateSchema("Added Favorite notification icon", "Icon for the Favorite added notification", {
    defaultValues: {
      container: { width: '3rem', height: '3rem' },
      icon: 'yc_icon_check_fill',
      iconColor: 'green'
    }
  }),
  closeToast: ButtonParticleSpec.generateSchema("Close notification icon", "Icon for the close notification button", {
    defaultValues: {
      image: {
        container: { width: '2rem', height: '2rem', margin: '0px 0px 0.5rem 0px' },
        icon: 'yc_icon_close',
        iconColor: '#585858'
      }
    }
  }),
  toastMessage: TextParticleSpec.generateSchema("Notification message", "Message displayed in the favorites added notification", {
    defaultValues: {
      text: 'Successfully added to playlist',
      container: { padding: '0px 0px 0.8rem 0.5rem' }
    }
  })
}));

export const specification = FavoriteParticleSpec;

export type FavoriteParticleSchema = GetParticleSchemaType<typeof FavoriteParticleSpec>;

export type FavoriteParticleProps = GetParticlePropsType<typeof FavoriteParticleSpec>;
